import React from "react";

import Heading2Paragraph from '../titles/heading2-paragraph';
import FeatureRow1 from '../features/feature1-row';
import SectionContainer from '../containers/section-container';

export default class FeatureContainer extends React.Component {
    render() {
        return (
            <SectionContainer>
                <Heading2Paragraph content={ this.props.titleContent } />
                <FeatureRow1 featureItems = { this.props.featureItems } />
            </SectionContainer>
        )
    };
};


// WEBPACK FOOTER //
// ./src/components/containers/feature-container.jsx